import { useEffect, useState } from 'react';

export function useMinuteClock(): number {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    const updateNow = () => setNow(Date.now());
    const interval = window.setInterval(updateNow, 60_000);
    document.addEventListener('visibilitychange', updateNow);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', updateNow);
    };
  }, []);

  return now;
}
